import React from 'react'
import { useTranslation } from 'next-i18next';

const ErrorMessage = ({
    error,
    touched
}) => {

    const { t } = useTranslation();

    if (touched && error) {
        return (
            <div className="flex-wrap text-sm text-red-600 min-h-6 ">
                {t(error.key, error.values)}
            </div>
        )
    }

    return <div className="flex-wrap h-6"></div>
}

export default ErrorMessage;
